import { useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltyError } from '@/Logalty/ui/molecules'
import { useUserData } from '@/User/ui/context'

export const ContractNewProductsStep5ErrorScreen = (): JSX.Element => {
  const { t } = useTranslation()
  const { getUserData } = useUserData()

  const {
    navigateToOrigin,
    logalty: { signStatus },
  } = useContractNewProducts()

  const handleReturn = (): void => {
    getUserData().then(() => {
      navigateToOrigin()
    })
  }

  return (
    <LogaltyError
      title={t(
        productContractingTranslation.contractProductPage.confirmationScreen.error.title,
      )}
      description={t(
        productContractingTranslation.contractProductPage.confirmationScreen.error
          .description,
      )}
      buttonLabel={t(
        productContractingTranslation.contractProductPage.confirmationScreen.error.button
          .label,
      )}
      signStatus={signStatus}
      returnCallback={handleReturn}
    />
  )
}
